import styled from 'styled-components'
import Icon from './Icon'

const MobileIcon = styled(Icon).attrs({
  type: 'mobile',
})``

export default MobileIcon
